import { render } from "./InteractiveTableWidget.vue?vue&type=template&id=56ccfd98&scoped=true"
import script from "./InteractiveTableWidget.vue?vue&type=script&lang=js"
export * from "./InteractiveTableWidget.vue?vue&type=script&lang=js"

import "./InteractiveTableWidget.vue?vue&type=style&index=0&id=56ccfd98&scoped=true&lang=css"

import exportComponent from "/opt/approot/build.20261030-093834-708061d9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ccfd98"]])

export default __exports__